// extracted by css-extract-rspack-plugin
export default {"cls1":"server_side_bulk_downloader-cls1_TGQ","cls2":"server_side_bulk_downloader-cls2_-FK server_side_bulk_downloader-cls1_TGQ"};